import MarkupPanel from './MarkupPanel';

export default MarkupPanel;
